const parseJson = async (response) => {
  const json = await response.json();
  return {
    status: response.status,
    ok: response.ok,
    json,
  };
};

const callApi = async (route, method, body, auth) => {
  const API_URL = globalThis.env?.API_URL || "http://localhost:3051/api/v1";
  let result;

  try {
    const response = await fetch(`${API_URL}${route}`, {
      method: method,
      headers: {
        "content-type": "application/json",
        accept: "application/json",
        authorization: auth && `Bearer ${auth}`,
      },
      body: body && JSON.stringify(body),
    });
    result = await parseJson(response);
  } catch (err) {
    if (err.message === "Failed to fetch") {
      throw new Error("Could not connect to API");
    }
  }

  if (result.ok) {
    return result.json;
  } else {
    const err = new Error(result.json?.detail || result.json?.message);
    err.status = result.status;
    throw err;
  }
};

export default callApi;
